<template>
    <div class="visuallyhidden" role="status" aria-live="polite" aria-atomic="true">
        {{ message }}
    </div>
</template>

<script setup>
import { ref } from 'vue';

defineExpose({
    setMessage,
});

const message = ref('');

function setMessage(newMessage) {
    message.value = '';
    message.value = newMessage;
    setTimeout(() => {
        message.value = '';
    }, 3000);
}
</script>
